import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { inputsProp, dynamicUpdateProp } from 'common/questionnaires/questionDataProp';
import { connect } from 'react-redux';
import { questionAnswered, questionErrored } from 'actions/questionnaires';
import { InputType } from 'common/questionnaires/types';

import { getJurisdictions } from 'actions';

const QuestionDropDown = ({ id, name, isForm, runValidation, jurisdictionsLoading, jurisdictions, usTaxTreatyCountries, dispatch, inputs, answer, dynamicUpdate }) => {
  const [selectedValue, setSelectedValue] = useState((inputs && inputs.defaultValue && inputs.defaultValue.value) ? inputs.defaultValue.value : '');
  const defaultValue = inputs && inputs.defaultValue && inputs.defaultValue.label ? inputs.defaultValue.label : 'Please Select Country';

  let dropdownItems = (inputs && inputs.items) ? [...inputs.items] : [];

  if (inputs.type === InputType.CountryDropdown) {
    if (name === 'treatyCountry') {
      if (usTaxTreatyCountries && usTaxTreatyCountries.length) {
        dropdownItems = [defaultValue, ...usTaxTreatyCountries];
      }
    } else if (jurisdictions && jurisdictions.length) {
      dropdownItems = [defaultValue, ...jurisdictions];
    } else if (!jurisdictionsLoading) {
      dropdownItems = ['Error, please refresh the page'];
    }
  }

  const validateSelect = (value) => {
    if (!value || (inputs.invalidSelection && value && inputs.invalidSelection === value)) {
      dispatch(questionErrored({ id, isForm }));
    } else {
      dispatch(questionAnswered({ id, answer: (value === 'NA' || value === '0' || value === defaultValue) ? '' : value, isForm, name }));
    }
  };

  const handleChange = (event) => {
    if (event.target && event.target.value) {
      setSelectedValue(event.target.value);
      validateSelect(event.target.value);
    }
  };

  useEffect(() => {
    if (!jurisdictionsLoading && !jurisdictions) {
      dispatch(getJurisdictions());
    }
    if (runValidation) {
      validateSelect(selectedValue);
    }
  }, [runValidation]);

  useEffect(() => {
    if (inputs.defaultValue && !inputs.invalidSelection) {
      validateSelect(selectedValue);
    }
  }, []);

  return (
    <div>
      <select id={ id } aria-label={ name } name={ name } value={ selectedValue } onChange={ event => handleChange(event) }>
        {inputs.type === InputType.CountryDropdown && dropdownItems && dropdownItems.map(i => <option key={ i } value={ i } label={ i }>{ i }</option>) }
        {inputs.type !== InputType.CountryDropdown && dropdownItems && dropdownItems.map(i => <option key={ i.value } value={ i.value } label={ i.label }>{ i.label }</option>) }
      </select>
      {inputs.showSelected && answer && <p className="dropdown-selection">{answer}</p>}
    </div>);
};

QuestionDropDown.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  isForm: PropTypes.bool,
  runValidation: PropTypes.bool,
  jurisdictionsLoading: PropTypes.bool.isRequired,
  jurisdictions: PropTypes.arrayOf(PropTypes.string),
  usTaxTreatyCountries: PropTypes.arrayOf(PropTypes.string),
  dispatch: PropTypes.func.isRequired,
  inputs: inputsProp.isRequired,
  answer: PropTypes.string,
  dynamicUpdate: dynamicUpdateProp,
};

QuestionDropDown.defaultProps = {
  isForm: false,
  answer: null,
  runValidation: false,
  jurisdictions: [],
  dynamicUpdate: null,
  name: null,
  usTaxTreatyCountries: null,
};

const mapDispatchToProps = dispatch => ({ dispatch });

const mapStateToProps = (state) => {
  const {
    app: { onlineConfig, jurisdictionsLoading, staticData },
    formQuestionnaire: { runValidation }
  } = state;

  return {
    mode: onlineConfig && onlineConfig.preQualifyingQuestionnaireMode,
    jurisdictionsLoading,
    jurisdictions: (staticData && staticData.jurisdictions && staticData.jurisdictions.length !== 0) ? staticData.jurisdictions : [],
    usTaxTreatyCountries: (staticData && staticData.usTaxTreatyCountries && staticData.usTaxTreatyCountries.length !== 0) ? staticData.usTaxTreatyCountries : [],
    runValidation
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionDropDown);
